export default "__VITE_ASSET__DCZX51yC__"